import { type ReactNode } from 'react';
import type { Creator } from '@/types';
import { ApproacherStatCards } from './approacher-stat-cards';
import { BackLink } from './back-link';
import { CollectorHeader } from './collector-header';
import { RoleSections } from './stats-role-sections';

type StatsData = {
  today: number;
  week: number;
  month: number;
  total: number;
  recentLeads: Creator[];
};

type Props = {
  data: StatsData;
  targetId: string | undefined;
  collectorId: string | undefined;
  isAdmin: boolean;
  position: number;
  totalApproachers: number;
};

function StatsHeader({
  isAdmin,
  collectorId,
  targetId,
}: Pick<Props, 'isAdmin' | 'collectorId' | 'targetId'>): ReactNode {
  return (
    <>
      {isAdmin && collectorId && <BackLink />}
      {targetId && <CollectorHeader collectorId={targetId} />}
    </>
  );
}

function StatCardsSection(p: Props): ReactNode {
  return (
    <ApproacherStatCards
      today={p.data.today}
      week={p.data.week}
      month={p.data.month}
      total={p.data.total}
      position={p.position}
      totalApproachers={p.totalApproachers}
    />
  );
}

export function ApproacherStatsContent(p: Props): ReactNode {
  return (
    <div className="space-y-lg">
      <StatsHeader
        isAdmin={p.isAdmin}
        collectorId={p.collectorId}
        targetId={p.targetId}
      />
      <StatCardsSection {...p} />
      {p.targetId && (
        <RoleSections
          isAdmin={p.isAdmin}
          targetId={p.targetId}
          creators={p.data.recentLeads}
        />
      )}
    </div>
  );
}
